import api from './api';

/**
 * Get active announcements for current user
 */
export const getActiveAnnouncements = async () => {
  try {
    const response = await api.get('/announcements');
    return response.data.data.announcements;
  } catch (error) {
    console.error('Error fetching announcements:', error);
    throw error.response?.data || error;
  }
};

/**
 * Mark announcement as viewed
 */
export const markAnnouncementAsViewed = async (announcementId) => {
  try {
    const response = await api.post(`/announcements/${announcementId}/view`, {});
    return response.data;
  } catch (error) {
    console.error('Error marking announcement as viewed:', error);
    throw error.response?.data || error;
  }
};

/**
 * Dismiss announcement
 */
export const dismissAnnouncement = async (announcementId) => {
  try {
    const response = await api.post(`/announcements/${announcementId}/dismiss`, {});
    return response.data;
  } catch (error) {
    console.error('Error dismissing announcement:', error);
    throw error.response?.data || error;
  }
};

// ============ ADMIN FUNCTIONS ============

/**
 * Get all announcements (admin only)
 */
export const getAllAnnouncements = async () => {
  try {
    const response = await api.get('/announcements/admin/all');
    return response.data.data.announcements;
  } catch (error) {
    console.error('Error fetching all announcements:', error);
    throw error.response?.data || error;
  }
};

/**
 * Create new system announcement (admin only)
 */
export const createAnnouncement = async (announcementData) => {
  try {
    const response = await api.post('/announcements/admin/create', announcementData);
    return response.data.data.announcement;
  } catch (error) {
    console.error('Error creating announcement:', error);
    throw error.response?.data || error;
  }
};

/**
 * Update system announcement (admin only)
 */
export const updateAnnouncement = async (announcementId, announcementData) => {
  try {
    const response = await api.put(`/announcements/admin/${announcementId}`, announcementData);
    return response.data.data.announcement;
  } catch (error) {
    console.error('Error updating announcement:', error);
    throw error.response?.data || error;
  }
};

/**
 * Delete system announcement (admin only)
 */
export const deleteAnnouncement = async (announcementId) => {
  try {
    const response = await api.delete(`/announcements/admin/${announcementId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting announcement:', error);
    throw error.response?.data || error;
  }
};

/**
 * Deactivate announcement (admin only)
 */
export const deactivateAnnouncement = async (announcementId) => {
  try {
    const response = await api.post(`/announcements/admin/${announcementId}/deactivate`, {});
    return response.data;
  } catch (error) {
    console.error('Error deactivating announcement:', error);
    throw error.response?.data || error;
  }
};

const announcementService = {
  getActiveAnnouncements,
  markAnnouncementAsViewed,
  dismissAnnouncement,
  getAllAnnouncements,
  createAnnouncement,
  updateAnnouncement,
  deleteAnnouncement,
  deactivateAnnouncement
};

export default announcementService;
